<script>
import ContextMenuBase from '@/components-v2/common/context-menu/context-menu.base.vue'

export default {
  extends: ContextMenuBase,
  props: {
    handleIconClickFn: {
      type: Function,
      default: null,
    },
  },
  methods: {
    handleIconClick() {
      if (this.handleIconClickFn) {
        const menu = this
        this.handleIconClickFn(menu)
        return
      }

      const icon = document.getElementById(this.id)
      if (!icon) return
      const { right } = icon.getBoundingClientRect()
      this.targetX = window?.innerWidth - right - 130
      this.targetY = icon.offsetTop + icon.offsetHeight - 8
      this.$refs['context-menu'].show()
    },
  },
}
</script>
